import React from 'react';
import { NoSsr } from '@shared/components/NoSsr';
import { GuestSiteHeadCsr } from '../GuestSite/GuestSiteHeadCsr';
import { RegistrationThemeBackground } from './RegistrationThemeBackground';
import { LazyRegistrationGuest } from './RegistrationGuest.lazy';

// SSR the head (GuestSiteHeadCsr) so the link preview inherits the event's metadata; the form body stays
// client-only (NoSsr). RegistrationThemeBackground SSRs the page background so there's no white flash.
export const RegistrationGuestWithHead: React.FC<{ eventHandle: string; formId: string }> = ({ eventHandle, formId }) => (
  <>
    <GuestSiteHeadCsr eventHandle={eventHandle} />
    <RegistrationThemeBackground eventHandle={eventHandle} />
    <NoSsr>
      <LazyRegistrationGuest
        eventHandle={eventHandle}
        formId={formId}
      />
    </NoSsr>
  </>
);
